/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GaugeType {
  bound = 'bound',
  scale = 'scale',
  boolean = 'boolean',
  single_selection = 'single_selection',
  multi_selection = 'multi_selection',
  ordered_list = 'ordered_list',
  weight_distribution = 'weight_distribution',
}
